import React from "react";

const FormSection = ({ title, children }) => {
  return (
    <div className="p-4 border border-gray-300 rounded-md shadow-md bg-white">
      <h3 className="text-lg font-bold text-gray-800 mb-2">{title}</h3>
      {children}
    </div>
  );
};

export default FormSection;
